export default __webpack_public_path__ + "static/media/Basketball_03.ca7ffc93.png";